module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_03.f93f89c2.png";